import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { TelecallerSlotMasterService } from '../../../services/index';

@Component({
    selector: 'add-edit-telecaller-slot-window',
    templateUrl: './addEditTelecallerSlot.component.html'
})
export class AddEditTelecallerSlotComponent implements OnInit {
    @Output() slotUpdateEvent = new EventEmitter();

    title: string;
    slotdata: any = {};
    isLoading = false;

    statusList = ['Active', 'InActive'];

    constructor(
        public bsModalRef: BsModalRef,
        private telecallerSlotMasterService: TelecallerSlotMasterService,
        private toasterService: ToasterService
    ) { }

    ngOnInit(): void { }

    onSave(): void {
        let toast: any = { type: 'warning', title: 'WARNING' };

        if (_.isEmpty(_.toString(this.slotdata['slot_name']).trim())) {
            toast['body'] = 'Please Enter Slot Name';
            this.toasterService.pop(toast); return;
        }
        if (!this.slotdata['status']) {
            toast['body'] = 'Please Select Status';
            this.toasterService.pop(toast); return;
        }

        let data = {
            mode:      this.slotdata['mode'],
            slot_id:   this.slotdata['slot_id'] || '',
            slot_name: this.slotdata['slot_name'],
            order_no:  this.slotdata['order_no'] || 0,
            status:    this.slotdata['status']
        };

        this.isLoading = true;
        this.telecallerSlotMasterService.addUpdateSlot(data)
            .then((res: any) => {
                this.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    this.bsModalRef.hide();
                    this.slotUpdateEvent.emit();
                } else {
                    swal('Warning', res.message, 'warning');
                }
            })
            .catch(() => {
                this.isLoading = false;
                swal('ERROR', 'Something went wrong', 'error');
            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/telecallerSlotMaster/addEditTelecallerSlot.component.ts